import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaWindowClose } from 'react-icons/fa';
import CommonModal from './CommonModal';
import { catchError, outClick, maskingInfo, commonModalSetting } from 'JS/common';
import { getSubscriptions } from 'JS/API';
import { statusArr, subscriptionTypeArr } from 'JS/array';

const SubscriptionDetailModal = ({
  setModal,
  item,
  setExtendModal,
  setAlertBox: parentSetAlertBox,
}) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState('');
  const [alertBox, setAlertBox] = useState({
    mode: '',
    context: '',
    bool: false,
  });
  const navigate = useNavigate();

  const {
    user_pk,
    user_id,
    user_name,
    user_email,
    merchant_name,
    target_type,
    status,
    start_at,
    end_at,
    merchant_price,
    merchant_uid,
    pay_method,
    paid_at,
    event_uid,
    unique_uuid,
  } = item;

  // 해당 회원의 전체 이용권 이력 조회
  const fetchHistory = async () => {
    setLoading(true);
    const result = await getSubscriptions({
      page: 1,
      limit: 100,
      user_pk: user_pk,
      type: 'all',
      status: 'all',
    });
    if (typeof result === 'object') {
      setHistory(result?.data?.data || []);
    } else {
      catchError(result, navigate, setAlertBox, setAlert);
    }
    setLoading(false);
  };

  const formatDate = dateStr => {
    if (!dateStr) return '-';
    return dateStr.replace('T', ' ').substring(0, 16);
  };

  const formatPrice = price => {
    if (!price) return '-';
    return price.toLocaleString() + '원';
  };

  const getPayMethodLabel = method => {
    const methods = {
      card: '카드',
      trans: '계좌이체',
      vbank: '가상계좌',
      phone: '휴대폰',
    };
    return methods[method] || method || '-';
  };

  const handleExtend = () => {
    setModal(false);
    setExtendModal(true);
  };

  // 환불 - 서비스 준비중
  const handleRefund = () => {
    commonModalSetting(
      parentSetAlertBox || setAlertBox,
      true,
      'alert',
      '서비스 준비 중입니다.'
    );
  };

  useEffect(() => {
    fetchHistory();
    window.addEventListener('click', e => outClick(e, setModal));
    return () => window.removeEventListener('click', e => outClick(e, setModal));
  }, []);

  const isActive = status === 'active';
  const isOrder = target_type === 'ORDER';

  return (
    <>
      <div className='modal-background'>
        <div className='modal subscription-detail'>
          <div className='topBar'>
            <h2>이용권 상세 정보</h2>
            <div onClick={() => setModal(false)}>
              <FaWindowClose />
            </div>
          </div>
          <hr />
          <div className='wrap'>
            {/* 회원 정보 */}
            <div className='section'>
              <h3>회원 정보</h3>
              <div className='info-grid'>
                <div className='info-row'>
                  <span className='label'>회원명</span>
                  <span className='value'>
                    {user_name ? maskingInfo('name', user_name) : '-'}
                  </span>
                </div>
                <div className='info-row'>
                  <span className='label'>이메일</span>
                  <span className='value'>
                    {user_email ? maskingInfo('email', user_email) : '-'}
                  </span>
                </div>
                <div className='info-row'>
                  <span className='label'>아이디</span>
                  <span className='value'>
                    {user_id ? maskingInfo('id', user_id) : '-'}
                  </span>
                </div>
              </div>
            </div>

            {/* 이용권 정보 */}
            <div className='section'>
              <h3>이용권 정보</h3>
              <div className='info-grid'>
                <div className='info-row'>
                  <span className='label'>이용권명</span>
                  <span className='value'>{merchant_name || '-'}</span>
                </div>
                <div className='info-row'>
                  <span className='label'>유형</span>
                  <span className='value'>
                    {subscriptionTypeArr[target_type] || target_type}
                  </span>
                </div>
                <div className='info-row'>
                  <span className='label'>상태</span>
                  <span className={`value ${isActive ? 'active' : 'inactive'}`}>
                    {statusArr[status] || status}
                  </span>
                </div>
                <div className='info-row'>
                  <span className='label'>시작일</span>
                  <span className='value'>{formatDate(start_at)}</span>
                </div>
                <div className='info-row'>
                  <span className='label'>만료일</span>
                  <span className='value'>{formatDate(end_at)}</span>
                </div>
              </div>
            </div>

            {/* 결제 정보 (ORDER 타입인 경우) */}
            {isOrder && (
              <div className='section'>
                <h3>결제 정보</h3>
                <div className='info-grid'>
                  <div className='info-row'>
                    <span className='label'>결제금액</span>
                    <span className='value'>{formatPrice(merchant_price)}</span>
                  </div>
                  <div className='info-row'>
                    <span className='label'>결제수단</span>
                    <span className='value'>{getPayMethodLabel(pay_method)}</span>
                  </div>
                  <div className='info-row'>
                    <span className='label'>결제일시</span>
                    <span className='value'>{formatDate(paid_at)}</span>
                  </div>
                  <div className='info-row'>
                    <span className='label'>주문번호</span>
                    <span className='value'>{merchant_uid || '-'}</span>
                  </div>
                </div>
              </div>
            )}

            {/* 이벤트 정보 (EVENT 타입인 경우) */}
            {target_type === 'EVENT' && (
              <div className='section'>
                <h3>이벤트 정보</h3>
                <div className='info-grid'>
                  <div className='info-row'>
                    <span className='label'>이벤트 코드</span>
                    <span className='value'>{event_uid || '-'}</span>
                  </div>
                  <div className='info-row'>
                    <span className='label'>쿠폰 코드</span>
                    <span className='value'>{unique_uuid || '-'}</span>
                  </div>
                </div>
              </div>
            )}

            {/* 이용권 이력 */}
            <div className='section history'>
              <h3>이용권 이력</h3>
              {loading ? (
                <div className='loading'>로딩 중...</div>
              ) : history.length > 0 ? (
                <div className='history-table-wrap'>
                  <table className='history-table'>
                    <thead>
                      <tr>
                        <th>이용권명</th>
                        <th>유형</th>
                        <th>시작일</th>
                        <th>만료일</th>
                        <th>상태</th>
                      </tr>
                    </thead>
                    <tbody>
                      {history.map((h, idx) => (
                        <tr
                          key={h.subscription_id || h.id || idx}
                          className={h.subscription_id === item.subscription_id ? 'current' : ''}>
                          <td>{h.merchant_name || '-'}</td>
                          <td>{subscriptionTypeArr[h.target_type] || h.target_type}</td>
                          <td>{formatDate(h.start_at)?.substring(0, 10)}</td>
                          <td>{formatDate(h.end_at)?.substring(0, 10)}</td>
                          <td>{statusArr[h.status] || h.status}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className='no-history'>이력이 없습니다.</div>
              )}
            </div>

            {/* 액션 버튼 */}
            <div className='footer'>
              <div className='btn-group'>
                {isActive && (
                  <button className='extend-btn' onClick={handleExtend}>
                    이용권 연장
                  </button>
                )}
                {isOrder && isActive && (
                  <button className='refund-btn' onClick={handleRefund}>
                    환불 처리
                  </button>
                )}
                <button className='close-btn' onClick={() => setModal(false)}>
                  닫기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === 'logout') navigate('/');
          }}
        />
      )}
    </>
  );
};

export default SubscriptionDetailModal;